import HttpRequest from './HttpRequest'

class OrganizesTimelineOfComplianceProvider extends HttpRequest {
  findAll (query) {
    return this.get('/organizes-timeline-of-compliance/', query)
  }
}

export default OrganizesTimelineOfComplianceProvider
